var _a;
export { assert };
export { assertUsage };
export { assertWarning };
export { assertInfo };
export { getProjectError };
import { createErrorWithCleanStackTrace } from './createErrorWithCleanStackTrace';
import { getGlobalObject } from './getGlobalObject';
import { projectInfo } from './projectInfo';
import pc from '@brillout/picocolors';
const errorPrefix = `[${projectInfo.npmPackageName}@${projectInfo.projectVersion}]`;
const internalErrorPrefix = `${errorPrefix}[Bug]`;
const usageErrorPrefix = `${errorPrefix}[Wrong Usage]`;
const warningPrefix = `${errorPrefix}[Warning]`;
const infoPrefix = `${errorPrefix}[Info]`;
const numberOfStackTraceLinesToRemove = 2;
const globalObject = getGlobalObject('assert.ts', {
    versions: new Set(),
    alreadyLogged: new Set(),
});
const { versions } = globalObject;
const alreadyLogged = (_a = globalObject.alreadyLogged) !== null && _a !== void 0 ? _a : 
// TODO/eventually: remove
// We need to set the same default again because older react-streaming versions (published before 11.03.2025) don't set any default in their getGlobalObject() call
new Set();
assertSingleVersion();
function assert(condition, debugInfo) {
    if (condition) {
        return;
    }
    const debugStr = (() => {
        if (!debugInfo) {
            return '';
        }
        const debugInfoSerialized = typeof debugInfo === 'string' ? debugInfo : '`' + JSON.stringify(debugInfo) + '`';
        return `Debug info (this is for the ${projectInfo.projectName} maintainers; you can ignore this): ${debugInfoSerialized}.`;
    })();
    const internalError = createErrorWithCleanStackTrace([
        `${internalErrorPrefix} You stumbled upon a bug in ${projectInfo.projectName}'s source code.`,
        `Reach out at ${projectInfo.githubRepository}/issues/new and include this error stack (the error stack is usually enough to fix the problem).`,
        'A maintainer will fix the bug (usually under 24 hours).',
        `Do not hesitate to reach out as it makes ${projectInfo.projectName} more robust.`,
        debugStr,
    ].join(' '), numberOfStackTraceLinesToRemove);
    throw internalError;
}
function assertUsage(condition, errorMessage) {
    if (condition) {
        return;
    }
    const whiteSpace = errorMessage.startsWith('[') ? '' : ' ';
    const usageError = createErrorWithCleanStackTrace(`${usageErrorPrefix}${whiteSpace}${errorMessage}`, numberOfStackTraceLinesToRemove);
    throw usageError;
}
function getProjectError(errorMessage) {
    const pluginError = createErrorWithCleanStackTrace(`${errorPrefix} ${errorMessage}`, numberOfStackTraceLinesToRemove);
    return pluginError;
}
function assertWarning(condition, errorMessage, { onlyOnce, showStackTrace }) {
    if (condition) {
        return;
    }
    const msg = `${warningPrefix} ${errorMessage}`;
    if (onlyOnce) {
        const key = onlyOnce === true ? msg : onlyOnce;
        if (alreadyLogged.has(key)) {
            return;
        }
        else {
            alreadyLogged.add(key);
        }
    }
    if (showStackTrace) {
        console.warn(new Error(msg));
    }
    else {
        console.warn(msg);
    }
}
function assertInfo(condition, errorMessage, { onlyOnce }) {
    if (condition) {
        return;
    }
    const msg = `${infoPrefix} ${errorMessage}`;
    if (onlyOnce) {
        const key = msg;
        if (alreadyLogged.has(key)) {
            return;
        }
        else {
            alreadyLogged.add(key);
        }
    }
    console.log(msg);
}
function assertSingleVersion() {
    versions.add(projectInfo.projectVersion);
    if (versions.size >= 2) {
        const versionsStr = Array.from(versions)
            .map((v) => `${projectInfo.projectName}@${v}`)
            .join(' and ');
        assertWarning(false, `${versionsStr} loaded which is highly discouraged, see ${pc.underline('https://vike.dev/warning/version-mismatch')}`, { onlyOnce: true });
    }
}
